import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Loader from "../components/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function BriefForms() {
  const { country } = useParams();
  const isAdmin = Cookies.get("user_role") === "Administrator";
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);

  const headers = { Authorization: apiKey };

  const loadItems = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/getbriefforms/${encodeURIComponent(country)}`, { headers })
      .then((res) => {
        setItems(res.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadItems();
  }, [country]);

  const resetForm = () => {
    setEditingId(null);
    setTitle("");
    setFile(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      alert("Title is required.");
      return;
    }
    if (!editingId && !file) {
      alert("File is required.");
      return;
    }
    const formData = new FormData();
    formData.append("Title", title.trim());
    if (editingId) {
      formData.append("Id", editingId);
    } else {
      formData.append("Country", country);
    }
    if (file) formData.append("file", file);

    const url = editingId ? `${BASE_URL}/updatebriefform` : `${BASE_URL}/addbriefform`;
    const method = editingId ? axios.put : axios.post;

    method(url, formData, { headers })
      .then(() => {
        resetForm();
        loadItems();
      })
      .catch((error) => console.log(error));
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this brief form?")) return;
    axios
      .delete(`${BASE_URL}/deletebriefform/${id}`, { headers })
      .then(() => {
        if (editingId === id) resetForm();
        loadItems();
      })
      .catch((error) => console.log(error));
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>{country} - Brief Form</h2>
      <br />
      {isAdmin && (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4">
              <input
                className="form-control"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="col-sm-4">
              <input
                type="file"
                className="form-control"
                onChange={(e) => setFile(e.target.files && e.target.files[0])}
              />
            </div>
          </div>
          <br />
          <button className="btn btn-primary" type="submit">{editingId ? "Update" : "Upload"}</button>
          {editingId && <button className="btn btn-secondary ms-2" type="button" onClick={resetForm}>Cancel</button>}
          <br />
          <br />
        </form>
      )}

      <table className="table table-striped table-dark">
        <thead>
          <tr>
            <th>Title</th>
            <th>File Name</th>
            <th>Created At</th>
            <th>Download</th>
            {isAdmin && (
              <>
                <th>Edit</th>
                <th>Delete</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.Id}>
              <td>{item.Title}</td>
              <td>{item.FileName}</td>
              <td>{item.Created_At}</td>
              <td>
                <a className="btn btn-sm btn-warning" href={`${BASE_URL}/${item.FilePath.replace(/\\/g, "/")}`} target="_blank" rel="noreferrer">
                  Download
                </a>
              </td>
              {isAdmin && (
                <>
                  <td>
                    <button className="btn btn-sm btn-light" onClick={() => {
                      setEditingId(item.Id);
                      setTitle(item.Title);
                    }}>
                      Edit
                    </button>
                  </td>
                  <td>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.Id)}>
                      Delete
                    </button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {items.length === 0 && (
            <tr><td colSpan={isAdmin ? 6 : 4} className="text-center">No brief forms found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
